import { AnalyticsEventHandler } from '@sbercloud/ft-metrics-client';
import { CloudMetricClient } from '@sbercloud/ft-metrics-client';

import { getGlobalArgs } from '@/root/global';
import { isLocalEnv } from '@/utils/next';

import { analyticsGatewayV1 } from './http';

const metricsClient: AnalyticsEventHandler = dto => {
  analyticsGatewayV1.post<{
    success: boolean;
    lang: string;
    resultCode: string;
  }>({
    url: '/event',
    body: dto,
  });
};

const shouldApplyMetrics = !isLocalEnv(getGlobalArgs('NEXT_PUBLIC_ENV', 'local'));
export const metricClient = new CloudMetricClient({
  yandexMetricaIds: [getGlobalArgs('NEXT_PUBLIC_DOCS_YM_ID', ''), getGlobalArgs('NEXT_PUBLIC_SITE_YM_ID', '')],
  googleAnalyticsId: getGlobalArgs('NEXT_PUBLIC_GTM_ID', ''),
  submitAnalyticsEventHandler: shouldApplyMetrics ? metricsClient : undefined,
  loggingEnabled: shouldApplyMetrics,
});
